import { Button } from "antd";
import { ReactComponent as KakaoLoginButton } from "../../assets/images/kakaoLoginButton.svg"
import { ReactComponent as NaverLoginButton } from "../../assets/images/naverLoginButton.svg"
import { checkDevAndLocal } from "../../utils"
const DevLogin = () => {
    const KAKAO_AUTH_URL = `kauth.kakao.com/oauth/authorize?client_id=${process.env.REACT_APP_KAKAO_LOGIN_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_KAKAO_LOGIN_REDIRECT_URI}&response_type=code&lang=ko&scope=phone_number,birthday,birthyear,gender,profile,account_email,name`;
    const NAVER_AUTH_URL = `nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${process.env.REACT_APP_NAVER_LOGIN_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_NAVER_LOGIN_REDIRECT_URI}&state=${process.env.REACT_APP_NAVER_LOGIN_STATE}&lang=ko_KR`;
    const clickKakaoLogin = () => {
        window.location.href = "https://" + KAKAO_AUTH_URL;
    }
    const clickNaverLogin = () => {
        window.location.href = "https://" + NAVER_AUTH_URL;
    }
    const onClickTokenSet = (value?: string) => {
        const defaultValue = "eyJhbGciOiJIUzUxMiJ9.eyJtZW1iZXJJZCI6MzkzMCwibW9iaWxlIjoiMDEwNTg1MTMxMDAiLCJyb2xlIjpbIlJPTEVfVVNFUiJdLCJpYXQiOjE3NDcxMDQyMjQsImV4cCI6MTc0NzEwNjAyNCwiaXNzIjoiTE9DQUwifQ.TnezQYSws51k7iG-NsxMEjJZyMK6K-g0Y34Rt_UwaccE205n8wt7M4TQ_oVItLCfnRgyQaFvWCW1OwooVHki4Q";
        localStorage.setItem('positivehotel-yoga-client-accessToken', value ?? defaultValue);
    }
    return <> {(checkDevAndLocal() === 'dev' || checkDevAndLocal() === 'local') &&
        <div style={{ border: '1px solid black' }}>
            테스트 용 Web Login 버튼
            <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                <KakaoLoginButton style={{ cursor: "pointer" }} onClick={clickKakaoLogin} />
                <NaverLoginButton style={{ cursor: "pointer" }} onClick={clickNaverLogin} />
                <Button href="/applelogin/callback">애플로그인 테스트</Button>
                {process.env.REACT_APP_DOMAIN === 'http://localhost:3000' && <Button onClick={() => onClickTokenSet()}>강제 로그인</Button>}
            </div>
        </div>}
    </>
}

export { DevLogin }